import { defineStore } from "pinia";
import { ref } from "vue";

import { useRuntimeStore } from "@/store/runtime"

import { useApi } from "@/service/api"


export const useNetworkStore = defineStore('networkStore', () => {

    const runtimeStore = useRuntimeStore();
    const api = useApi()

    let checkTrackerServerStatusSecondsDelay = 60
      if (ENVIRONMENT === "development") {
        checkTrackerServerStatusSecondsDelay = 10
      }


    const getEffectiveType = () => {
      let effectiveType = "-"
      if(navigator?.connection?.effectiveType){
          effectiveType = navigator.connection.effectiveType
      }
      else {
        console.log("🌐", navigator?.connection)
      }
      return effectiveType
    }

    const getType = () => {
      let plainType = null
      if(navigator?.connection?.type){
          plainType = navigator.connection.plainType
          // enum ConnectionType {
          //   "cellular",
          //   "wifi",
          //   "wimax",
          //   "bluetooth",
          //   "ethernet",
          //   "mixed",
          //   "other",
          //   "unknown",
          //   "none"
          // };
      }
      else {
        console.log("🌐", navigator?.connection)
      }
      return plainType
    }

    const getDownlink = () => {
      let downlink = "-"
      if(navigator?.connection?.downlink){
          downlink = navigator.connection.downlink
      }
      else {
        console.log("🌐", navigator?.connection)
      }
      return downlink
    }

    const online = ref(navigator?.onLine)
    
    const trackerServerStatus = ref(false)

    const effectiveType = ref(getEffectiveType())
    const plainType = ref(getType())
    const downlink = ref(getDownlink())

    const updateConnectionStatus = () => {
        online.value = navigator.onLine;
        effectiveType.value = getEffectiveType()
        plainType.value = getType()
        downlink.value = getDownlink()
        console.log("🌐", navigator?.connection)

        checkTrackerServerStatus()
      };

    window.addEventListener('online', updateConnectionStatus);
    window.addEventListener('offline', updateConnectionStatus);

    if (navigator?.connection) {
      navigator.connection.addEventListener('change', updateConnectionStatus);
    }

    const checkTrackerServerStatus = async () => {

      // console.log("Checking tracker server status... DISABLED")
      // return

      const result = await api.tracker.upcheck()
      // console.log("🌐", result)
      trackerServerStatus.value = result

      // try {
      //   const response = await fetch(runtimeStore.session.settings.tracker_server_url + "/picker/api/upcheck", {
      //     method: 'HEAD',
      //     headers: {
      //       'Content-Type': 'application/json',
      //     },
      //   })

      //   trackerServerStatus.value = response?.ok
      // }
      // catch (error) {
      //   trackerServerStatus.value = false
      // }
      // // console.log("🌐", trackerServerStatus.value)
    }


    setInterval(checkTrackerServerStatus, checkTrackerServerStatusSecondsDelay*1000)
    checkTrackerServerStatus()

  return {
    online,
    downlink,
    effectiveType,
    plainType,
    // checkTrackerServerStatus,
    trackerServerStatus,

  }
})
